import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CorporateListComponent } from './components/corporate-list/corporate-list.component';
import { CorporatePageComponent } from './components/corporate-page/corporate-page.component';
import { CorporateAddComponent } from './components/corporate-add/corporate-add.component';

const routes: Routes = [
  {
    path: '',
    component: CorporatePageComponent,
    data: { title: '' },
    children: [
      {
        path: '',
        component: CorporateListComponent,
        data: { title: '' },
      },
      {
        path: 'add',
        component: CorporateAddComponent,
        data: { title: '' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CorporateRoutingModule {}
